/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Free_QInputs */

const en_wc_faq_free_q = /** @type {(inputs: Wc_Faq_Free_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need to pay or create an account?`)
};

/**
* | output |
* | --- |
* | "Do I need to pay or create an account?" |
*
* @param {Wc_Faq_Free_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_free_q = /** @type {((inputs?: Wc_Faq_Free_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Free_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_free_q(inputs)
});
export { wc_faq_free_q as "wc.faq.free.q" }